module.exports = __webpack_public_path__ + "static/media/Zeiser-Dark.79d2d53c.webp";